// @flow

// Skipping story doc and test coverage for this component since it is not possible to do it correctly
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
/* istanbul ignore file */

import Observable from 'zen-observable';
import { ApolloLink } from 'apollo-link';

import { type Operation } from '@ta/platform.graphql';

/**
 * Batched link that uses the microservice caller.
 *
 * @author skline
 * @since 2018-06-26
 */
class MicroserviceBatchLink extends ApolloLink {
  queue = [];
  observers = [];

  request(operation: Operation) {
    this.queue.push(operation);
    return new Observable(observer => {
      this.observers.push(observer);
    });
  }
}

// Export an instance of this link so that it is a singleton (everything should be batched together)
const microserviceBatchLink = new MicroserviceBatchLink();
export default microserviceBatchLink;

/**
 * Function to force the queue of batched requests to be fulfilled with the given data.
 */
export const fulfill = (results: Array<any>) => {
  if (results.length !== microserviceBatchLink.queue.length) {
    throw new Error(
      `Apollo SSR response length ${results.length} does not match queue length ${
        microserviceBatchLink.queue.length
      }`,
    );
  }
  results.forEach((result, i) => {
    microserviceBatchLink.queue[i].setContext({ response: result });
    const o = microserviceBatchLink.observers[i];
    o.next(result);
    o.complete();
  });
};

/**
 * Returns the requests sitting in the batcher's queue.
 */
export const getQueuedRequests = (): $ReadOnlyArray<Operation> => microserviceBatchLink.queue;
